if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        if (!this.openedBy) return;

        const mediaId = this.openedBy.getAttribute('data-media-id');

        if (!mediaId) return;

        this.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.toggle(
            'active',
            element.getAttribute('data-media-id') === mediaId
          );
        });

        const activeMedia = this.querySelector(
          `[data-media-id="${mediaId}"]`
        );

        if (!activeMedia) return;

        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate
          ? activeMediaTemplate.content
          : null;

        activeMedia.classList.add('active');

        requestAnimationFrame(() => {
          activeMedia.scrollIntoView({
            block: 'start',
            inline: 'center'
          });

          const container = this.querySelector('[role="document"]');

          if (container) {
            container.scrollLeft = Math.max(
              0,
              (activeMedia.scrollWidth - container.clientWidth) / 2
            );
          }
        });

        if (
          activeMedia.nodeName === 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        ) {
          activeMedia.loadContent();
        }
      }
    }
  );
}


/*
  PetSure DX fallback handler.

  This forces Open Lightbox to work even if the theme's
  modal-opener custom element does not register the click.
*/

document.addEventListener('click', function (event) {
  const imageButton = event.target.closest(
    '.product__media-toggle[data-media-id]'
  );

  if (!imageButton) return;

  const modalOpener = imageButton.closest('modal-opener');

  if (!modalOpener) return;

  const modalSelector = modalOpener.getAttribute('data-modal');

  if (!modalSelector) return;

  const modal = document.querySelector(modalSelector);

  if (!modal || typeof modal.show !== 'function') return;

  /*
    If Dawn's normal handler already opened the modal,
    don't open it a second time.
  */

  if (modal.hasAttribute('open')) return;

  event.preventDefault();
  event.stopPropagation();

  modal.show(imageButton);
});


/*
  Keyboard support for the large image.
*/

document.addEventListener('keydown', function (event) {
  if (event.key !== 'Enter' && event.key !== ' ') return;

  const imageButton = event.target.closest(
    '.product__media-toggle[data-media-id]'
  );

  if (!imageButton) return;

  event.preventDefault();
  imageButton.click();
});